import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Testimonial {
	id: number;
	name: string;
	role: string;
	content: string;
	rating: number;
	display_order: number;
	is_active: boolean;
	created_at?: string;
	updated_at?: string;
}

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class TestimonialService {
	private http = inject(HttpClient);
	private apiUrl = environment.apiUrl;

	// Public API
	getActive(): Observable<ApiResponse<Testimonial[]>> {
		return this.http.get<ApiResponse<Testimonial[]>>(`${this.apiUrl}/public/testimonials`);
	}

	// Admin APIs
	getAll(): Observable<ApiResponse<Testimonial[]>> {
		return this.http.get<ApiResponse<Testimonial[]>>(`${this.apiUrl}/admin/testimonials`);
	}

	getById(id: number): Observable<ApiResponse<Testimonial>> {
		return this.http.get<ApiResponse<Testimonial>>(`${this.apiUrl}/admin/testimonials/${id}`);
	}

	create(data: Partial<Testimonial>): Observable<ApiResponse<Testimonial>> {
		return this.http.post<ApiResponse<Testimonial>>(`${this.apiUrl}/admin/testimonials`, data);
	}

	update(id: number, data: Partial<Testimonial>): Observable<ApiResponse<Testimonial>> {
		return this.http.put<ApiResponse<Testimonial>>(`${this.apiUrl}/admin/testimonials/${id}`, data);
	}

	delete(id: number): Observable<ApiResponse<null>> {
		return this.http.delete<ApiResponse<null>>(`${this.apiUrl}/admin/testimonials/${id}`);
	}

	reorder(testimonials: { id: number; display_order: number }[]): Observable<ApiResponse<null>> {
		return this.http.post<ApiResponse<null>>(`${this.apiUrl}/admin/testimonials/reorder`, { testimonials });
	}
}
